<template>
    <div class="two">
        <div class="two-left">
            <button-create class="mb-5" variant="teal" :label="$t('common.create_prescription')"
                :subtitle="$t('common.create_prescription_hint')" icon="mdi-plus" @click="showCreatePrescription" />

            <div class="mu">
                <most-used-carousel type="prescriptions" customTitleStyle :coachId="coachId" />
            </div>

            <div class="sec-hd">
                <span class="sec-tit">{{ $t('common.categories') }}</span>
            </div>
            <div class="fg">
                <category-card v-for="category in categoriesOptions" :key="category.id" :category="category"
                    :is-active="isActiveCategory(category)" @click="onSelectCategory(category)" />
            </div>
        </div>

        <div class="rc">
            <div class="panel-srch">
                <kimsa-text-field class="srch-input" @change="setSearch" :value="search"
                    :placeholder="$t('common.search_name_tag')" prepend-inner-icon="mdi-magnify" dense />
                <button-tooltip :tooltip="$t('common.refresh')" top>
                    <template v-slot:activator="{ on, attrs }">
                        <button type="button" class="refresh-btn" @click="refresh" v-bind="attrs" v-on="on">
                            <v-icon size="16">mdi-refresh</v-icon>
                        </button>
                    </template>
                </button-tooltip>
            </div>
            <div class="rch">
                <span class="rct">{{ rightTitle }}</span>
            </div>
            <prescriptions @loading="loading = $event" :search="search" :category="categoryId" :coach-id="coachId"
                :total-visible-pagination="5" ref="prescriptions" />
        </div>

        <create-prescription-dialog ref="createPrescriptionDialog" :coachId="coachId" @success="onPrescriptionSaved" />
    </div>
</template>

<script>
import CategoryCard from '@/components/common/cards/CategoryCard'
import Prescriptions from '@/components/coach/routines/Prescriptions';
import { mapState, mapActions } from 'vuex';
import CreatePrescriptionDialog from '../routines/CreatePrescriptionDialog.vue';
import MostUsedCarousel from '../MostUsedCarousel.vue';
import ButtonCreate from '../../common/inputs/ButtonCreate.vue';
import KimsaTextField from '../../common/inputs/KimsaTextField.vue';
import ButtonTooltip from '@/components/common/ButtonTooltip';

export default {
    name: "PrescriptionsTab",
    components: { CategoryCard, Prescriptions, CreatePrescriptionDialog, MostUsedCarousel, ButtonCreate, KimsaTextField, ButtonTooltip },
    data() {
        return {
            search: '',
            loading: false,
            categoryId: null,
        }
    },
    computed: {
        ...mapState(['categoriesOptions', 'libraryCoach']),
        companyId(vm = this) {
            return vm.account?.coachSubscription?.companyId || vm.currentUser?.uid || null
        },
        coachId(vm = this) {
            if (vm.isCompany) return vm.libraryCoach?.id || null
            return vm.currentUser?.uid || null
        },
        rightTitle(vm = this) {
            if (vm.categoryId) {
                const cat = vm.categoriesOptions.find(c => c.id === vm.categoryId)
                if (cat) return vm.categoryLabel(cat.name)
            }
            return vm.$t('common.prescriptions')
        },
    },
    async mounted() {
        const vm = this;
        if (vm.categoriesOptions.length === 0) await vm.fetchExerciseCategories()
    },
    methods: {
        ...mapActions(['fetchExerciseCategories']),
        onSelectCategory(category) {
            const vm = this
            if (vm.categoryId === category?.id) return vm.categoryId = null
            vm.categoryId = category?.id || null
        },
        isActiveCategory(category) {
            const vm = this
            return vm.categoryId === category.id
        },
        setSearch(search) {
            const vm = this;
            vm.search = search || ''
        },
        refresh() {
            const vm = this;
            if (vm.$refs.prescriptions) vm.$refs.prescriptions.refresh()
        },
        onPrescriptionSaved(prescription) {
            const vm = this;
            if (vm.$refs.prescriptions) vm.$refs.prescriptions.onPrescriptionSaved(prescription)
        },
        showCreatePrescription() {
            const vm = this;
            vm.$refs.createPrescriptionDialog.show()
        }
    },
    watch: {
        loading(val) {
            this.$emit('loading', val)
        },
    },
}
</script>

<style scoped>
.two {
    display: grid;
    grid-template-columns: 1fr 360px;
    gap: 24px;
    align-items: start;
}

.two-left {
    min-width: 0;
}

.mu {
    margin-bottom: 20px;
}

.sec-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.sec-tit {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.fg {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.rc {
    min-width: 0;
}

.panel-srch {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.srch-input {
    flex: 1;
}

.refresh-btn {
    width: 38px;
    height: 38px;
    min-width: 38px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--v-txtMuted-base);
    flex-shrink: 0;
    transition: all .15s;
}

.refresh-btn:hover {
    color: var(--v-txtSecondary-base);
    border-color: var(--v-outline2-base);
}

.refresh-btn .v-icon {
    color: inherit !important;
}

.rch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.rct {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

@media (max-width: 960px) {
    .two {
        grid-template-columns: 1fr;
    }
}
</style>
